/* Component rendered on the ProfilesPage to display the 
   cover info for each Profile
 * When clicked on it opens that Profile's ProfilePage 
 * Contains the handleFollow and handleUnFollow functions
   from useSetProfileData */
import React from "react"
import styles from "../../styles/Profile.module.css"
import btnStyles from "../../styles/Button.module.css"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { Link } from "react-router-dom"
import Avatar from "../../components/Avatar"
import Button from "react-bootstrap/Button"
import { useSetProfileData } from "../../contexts/ProfileDataContext"
import Card from "react-bootstrap/Card"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

const Profile = (props) => {
  const { profile } = props 
  const { id, following_id, image, owner, name, position, 
    // call_time_username
   } = profile

  const currentUser = useCurrentUser()
  const is_owner = currentUser?.username === owner
  // console.log(currentUser)
  // console.log(profile)

  const { handleFollow, handleUnfollow } = useSetProfileData()

  return (
    <div className="mt-1 text-center">
      <Card className={`px-0 my-0 py-1 ${styles.Back}`}>
      <Card.Body className={`px-0 py-0 ${styles.CardHead}`}>
          <Link to={`/${localStorage.getItem("projectSlug")}/profiles/${id}`}>              
          <Row className="my-0 pt-1">
            <Col xs={12}>
              <Avatar className="my-0 py-0" src={image} height="40" />
            </Col>
          </Row>
          <Row className={`${styles.WhiteT} mt-2`} >
            <Col xs={12}>
              <div>
                <p className={`pb-0 mb-0`} style={{ textTransform: "capitalize" }}>
                  {name}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p
                style={{ textTransform: "capitalize" }}
                className={`mb-0 pb-0 ${styles.WordBreakWhite}`}
              >
                {position}{" "}
              </p>
            </Col>
          </Row>
          <Row >
            <Col xs={12}>
              <div >
                {currentUser &&
                  !is_owner &&
                  (following_id ? (
                    <Button
                      className={`py-0 ${btnStyles.Button} ${btnStyles.BlackP}`}
                      onClick={() => handleUnfollow(profile)}
                    >
                      Unfollow
                    </Button>
                  ) : (
                    <Button
                      className={`py-0 px-4 ${btnStyles.Button} ${btnStyles.White}`}
                      onClick={() => handleFollow(profile)}
                    >
                      Follow
                    </Button>
                  ))}
              </div>
            </Col>
          </Row>
          </Link>
      </Card.Body>
      </Card>
    </div>
  )
}

export default Profile
